// extracted by mini-css-extract-plugin
export default {"MobileMenu":"MobileMenu_MobileMenu__8BPJQ"};